import axios from 'axios';
import { API_SVC_HOST } from '@/config/common';
import _ from 'lodash';
// import { reftoken } from "./index"
// import moment from "moment"
import { ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/el-message.css'
import 'element-plus/es/components/message/style/css'
// import $router from '@/router'
import {errorMsg} from "@/helpers/swal";
import { getAcceptLanguage } from '@/i18n'
import i18n from "@/i18n";


function urlFormat(url) {
    return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/" + _.trimStart(url, "/")
}
function _getJwtToken() {
    return localStorage.getItem("accessToken")
}

// 创建axios实例 application/x-www-data-urlencoded;charset=UTF-8 application/json

var service = axios.create({
    baseURL: API_SVC_HOST,
    timeout: 300000,
    xhrFields: { withCredentials: true }
})
// function _refreshToken(data) {
//     return new Promise(resolve => {
//         //此接口为循环调用的接口，按照自己的需要进行修改
//         reftoken(data).then(res => {
//             resolve(res)
//         }).catch((err)=>{
//             console.log(err)
//             localStorage.clear()
//             $router.push({path:'/'})
//         })
//     });
// }

// service.interceptors.request.use(
//     async (reqConfig) => {
//         reqConfig.headers["Content-Type"] = "application/json"
//         let accessToken = _getJwtToken()
//         if (accessToken) {
//             reqConfig.headers["Authorization"] = "Bearer " + accessToken
//             //当前时间戳，秒
//             let timestamp = new Date().getTime();
//             //过了这个时间后需要刷新
//             let expiresAt = moment(localStorage.getItem("expiresAt")).valueOf()
//             let diff = moment(expiresAt).diff(moment(timestamp), "minutes");
//             //token存在的有效时间
//             //判断是否需要更换token(临近快过期10分钟内，刷新token)
//             if (diff <= 10) {
//                 //判断token是否过期
//                 let refreshToken = localStorage.getItem("refreshToken")
//                 //请求新的接口
//                 let data = {
//                     refreshToken: refreshToken
//                 }
//                 localStorage.removeItem("accessToken");
//                 let res = await _refreshToken(data)
//                 // 刷新accessToken 
//                 if (res && res.payload) {
//                     let accessToken = res.payload.accessToken;
//                     let expiresAt = res.payload.expiresAt;
//                     let refreshExpiresIn = res.payload.refreshExpiresIn;
//                     let refreshToken = res.payload.refreshToken;
//                     localStorage.setItem("accessToken", accessToken);
//                     localStorage.setItem("expiresAt", expiresAt);
//                     localStorage.setItem("refreshToken", refreshToken);
//                     localStorage.setItem("refreshExpiresIn", refreshExpiresIn);
//                     reqConfig.headers["Authorization"] = "Bearer " + accessToken
//                     return reqConfig
//                 } else {
//                     $router.replace({
//                         path: '/'
//                     })
//                     ElMessage.error("登录已过期，请重新登录！")
//                 }
//             } else {
//                 //不需要更换token
//                 reqConfig.headers["Authorization"] = "Bearer " + accessToken
//                 return reqConfig
//             }
//         } else {
//             return reqConfig;
//         }
//     },
//     err => Promise.reject(err),
// )
service.interceptors.request.use(
    reqConfig => {
        reqConfig.headers["Content-Type"] = "application/json"
        reqConfig.headers["Accept-Language"] = getAcceptLanguage()
        reqConfig.headers["Authorization"] = `Bearer ${_getJwtToken()}`
        // reqConfig.headers["Content-Encoding"]= "gzip";
        return reqConfig;
    },
    err => Promise.reject(err),
)

function request(url, params, options, type) {
    options = options || {}
    return new Promise((resolve, reject) => {
        service[type](urlFormat(url, options), params).then((response) => {
            resolve(response.data)

        }).catch((err) => {
            let isExpire = false
            let accessToken = localStorage.getItem('accessToken');
            let expiresAt = localStorage.getItem('expiresAt');
            if (accessToken && expiresAt) {
                expiresAt = new Date(expiresAt).getTime()
                let now = new Date().getTime()
                if (expiresAt <= now) {
                    isExpire = true
                    errorMsg("登录已过期，请重新登录！")
                    setTimeout(() => {
                        localStorage.clear()
                        window.location.href = "/"
                    }, 1000);
                }
            }
            if (!isExpire){
                if (err && err.response) {
                    let status = _.get(err.response, 'status')
                    let msg = _.get(err, 'response.data.meta.message', 'base.error_request')
                    switch (status) {
                        case 403:
                            ElMessage.error("无操作权限, 请联系管理员。")
                            break;
                        case 401:
                            ElMessage.error("用户名或密码错误")
                            console.log('是否闪现白屏~~~~~')
                            // $router.push({path:'/login'})
                            // setTimeout(() => {
                            //     localStorage.clear()
                            //     window.location.href = "/"
                            // }, 1000);
                            break;
                        case 500:
                            if (!url.includes(('latest')))
                                ElMessage.error("系统繁忙，请稍后再试。")
                            break;
                        case 504 :
                            if (!url.includes(('latest')))
                                ElMessage.error("系统繁忙，请稍后再试。")
                            break;
                        case 503:
                        case 502:
                            if (!url.includes(('latest')))
                                ElMessage.error("系统繁忙，请稍后再试。")
                            break;
                        case 404:
                            // ElMessage.error("系统暂时无法提供该服务。")
                            break;
                        case 400:
                            if (typeof msg === 'object' && msg.message) {
                                msg = msg.message
                            }
                            if (!['root_sn_exists', 'group_sn_exists'].includes(msg)) {
                                ElMessage.error(i18n.global.t(msg))
                            }
                            break;
                        case 429:
                            if (url.includes('/raw-query')) {
                                ElMessage.error("请求图谱次数过多,获取相关数据失败,请稍后再试。")
                            }
                            if (url.includes('/rest-api/events?')) {
                                ElMessage.error("请求次数过多，获取事件相关数据列表失败,请稍后再试。")
                            }
                            break;
                    }
                }
                else {
                    console.log(err.status)
                    ElMessage.error(err.message)
                }
                reject(err.response && err.response.data && err.response.data.payload || err);
            }
        });
    });
}

export function createAPI() {
    return {
        post(url, params, options) {
            return request(url, params, options, 'post');
        },
        get(url, params, options) {
            return request(url, { params }, options, 'get');
        },
        put(url, params, options) {
            params = Object.assign({}, params, {
                _method: 'PUT'
            });
            return request(url, params, options, 'put');
        },
        patch(url, params, options) {
            params = Object.assign({}, params, {
                _method: 'PATCH'
            });
            return request(url, params, options, 'patch');
        },
        delete(url, params, options) {
            // params = Object.assign({}, params, {
            //     _method: 'DELETE'
            // });

            return request(url, { data: params, _method: 'DELETE' }, options, 'delete');
        }
    };
}
